import { useLocation } from 'react-router-dom'
import { useWindowScroll } from '@mantine/hooks'
import { LAYOUT_CONSTANTS } from '@/constants/styles'

// Page-specific secondary nav configurations
const SECONDARY_NAV_CONFIG = {
  // Exact route matches
  '/etf/comparison': {
    scrollTrigger: 180,
    navHeight: 72
  },
  '/screener': {
    scrollTrigger: 180,
    navHeight: 75
  },
  '/blog': {
    scrollTrigger: 120,
    navHeight: 58
  },
  
  // Information pages
  '/assistance/faq': {
    scrollTrigger: 180,
    navHeight: 72
  },
  '/assistance/contact': {
    scrollTrigger: 180,
    navHeight: 72
  },
  '/about/about-us': {
    scrollTrigger: 180,
    navHeight: 72
  },
  '/about/terms-of-use': {
    scrollTrigger: 180,
    navHeight: 72
  },
  '/about/privacy-policy': {
    scrollTrigger: 180,
    navHeight: 72
  },
  
  // Dynamic route patterns
  'etf-detail': {
    scrollTrigger: 180,
    navHeight: 73
  },
  'blog-detail': {
    scrollTrigger: 120,
    navHeight: 68
  }
} as const

// Function to determine secondary nav config based on pathname
const getSecondaryNavConfig = (pathname: string) => {
  // Check exact matches first
  if (SECONDARY_NAV_CONFIG[pathname as keyof typeof SECONDARY_NAV_CONFIG]) {
    return SECONDARY_NAV_CONFIG[pathname as keyof typeof SECONDARY_NAV_CONFIG]
  }

  // Check dynamic route patterns
  if (pathname.startsWith('/etf/') && pathname !== '/etf/comparison') {
    return SECONDARY_NAV_CONFIG['etf-detail']
  }

  if (pathname.startsWith('/blog/') && pathname !== '/blog') {
    return SECONDARY_NAV_CONFIG['blog-detail']
  }

  // No secondary nav for this page
  return null
}

export const useSidebarOffset = () => {
  const location = useLocation()
  const [scroll] = useWindowScroll()

  const config = getSecondaryNavConfig(location.pathname)
  
  // If no secondary nav config, just return base height
  if (!config) {
    return {
      topOffset: `${LAYOUT_CONSTANTS.BASE_HEADER_HEIGHT}px`,
      maxHeight: `calc(100vh - ${LAYOUT_CONSTANTS.BASE_HEADER_HEIGHT}px)`
    }
  }

  // Check if secondary nav should be visible
  const isSecondaryNavVisible = scroll.y > config.scrollTrigger
  const totalOffset = isSecondaryNavVisible 
    ? LAYOUT_CONSTANTS.BASE_HEADER_HEIGHT + config.navHeight
    : LAYOUT_CONSTANTS.BASE_HEADER_HEIGHT

  return {
    topOffset: `${totalOffset}px`,
    maxHeight: `calc(100vh - ${totalOffset}px)`
  }
}